import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { VendorRegister } from '../../../models/VendorRegister';
import { AccountService } from '../../../services/account.service';
import { NgForm } from '@angular/forms';
import { ReCaptchaModule } from 'angular2-recaptcha';
import { ConfirmationPageSuccessComponent } from '../../../shared-components/confirmation-page-success/confirmation-page-success.component';
import { ConfirmationPageFailComponent } from '../../../shared-components/confirmation-page-fail/confirmation-page-fail.component';
import { Router } from '@angular/router';
import { ClientRegister } from '../../../models/ClientRegister';
import { ReCaptchaComponent } from 'angular2-recaptcha';
import { BusyIndicatorComponent } from '../../../shared-components/busy-indicator/busy-indicator.component';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-vendor-register',
  templateUrl: './vendor-register.component.html',
  styleUrls: ['./vendor-register.component.scss']
})
export class VendorRegisterComponent implements OnInit, OnDestroy {
  public register: VendorRegister = new VendorRegister();
  public showSuccessConfirmation = false;
  public showFailConfirmation = false;
  public successMsg: string;
  public errorMsg: string;
  public validRecaptcha = false;
  public showRecaptchaError = false;
  public recaptchaKey ='6LfL_FoUAAAAAMaHg2_CEaHoDRZw1Nng0a3tGssO';//'6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI'; test key //
  public isComparePasswordMatched = true;
  public termsOfUse = '';
  public privacyPolicy = '';
  public emailmatchMsg ='';
  alive = true;
  @ViewChild(ReCaptchaComponent) captcha: ReCaptchaComponent;
  constructor(private accountSvc: AccountService,
    private router: Router,
    private spinner: NgxSpinnerService ) { }

  async ngOnInit() {
    /// this.recaptchaKey = await this.accountSvc.getRecaptchaKey();
    /// this.termsOfUse = await this.accountSvc.getHtmlFile('terms1');
    /// this.privacyPolicy = await this.accountSvc.getHtmlFile('privacy1');
  }
  copyEmail() {
    if (this.register.universalFlag === true)   {
      this.register.UniversalEmail = this.register.Email;
    }

  }

  checkEmailExists() {
    this.emailmatchMsg = '';
    this.accountSvc.isEmailAlreadytExists(this.register.UniversalEmail).subscribe(
      data => {
                 if (data === true) {
                  this.successMsg = null;
                  this.emailmatchMsg = 'email address already exist';
                } else {
                  this.emailmatchMsg = '';
                }
            },
      err => {

          this.successMsg = null;
          this.errorMsg = err;

      }
    );
}

  onSubmit(frmVendorReg: NgForm) {
    if (this.register.IsAgreement && this.validRecaptcha) {
      this.register.Email = this.register.UniversalEmail;
      this.register.UserId  = this.register.UniversalEmail;
      frmVendorReg.controls['register.IsAgreement'].setErrors(null);
      frmVendorReg.controls['register.CompanyName'].setErrors(null);
      frmVendorReg.controls['register.VendorKey'].setErrors(null);
      this.errorMsg = null;
      this.successMsg = null;
      this.spinner.show();
      this.accountSvc.vendorRegister(this.register)
      .takeWhile(() => this.alive)
      .subscribe(
        data => {
                  this.spinner.hide();
                  if (data.Result === true) {
                    this.showSuccessConfirmation = true;
                    this.showFailConfirmation = false;
                    this.successMsg = 'Thank you for registering with us.';
                    this.errorMsg = null;
                    this.register = new VendorRegister();
                    frmVendorReg.reset();
                  } else {
                    this.showSuccessConfirmation = false;
                    this.showFailConfirmation = true;
                    this.successMsg = null;
                    this.errorMsg = 'Failed to register the user. Please contact Client Services at clientservices@jetsupport.com or 1-888-4My-JSSI or +1 312 494-8600 if outside the US.';
                  }
              },
        err => {
                  this.spinner.hide();
                  this.showSuccessConfirmation = false;
                  this.showFailConfirmation = true;
                  this.successMsg = null;
                  this.errorMsg = err._body;

                  if (this.errorMsg.indexOf('Company') > -1) {
                    frmVendorReg.controls['register.CompanyName'].setErrors({'incorrect' : true});
                  } else {
                    frmVendorReg.controls['register.CompanyName'].setErrors(null);
                  }

                  if (this.errorMsg.indexOf('Vendor Key') > -1) {
                    frmVendorReg.controls['register.VendorKey'].setErrors({'incorrect' : true});
                  } else {
                    frmVendorReg.controls['register.VendorKey'].setErrors(null);
                  }
          }
      );
    } else {
      if (!this.register.IsAgreement) {
        frmVendorReg.controls['register.IsAgreement'].setErrors({'incorrect' : true});
      } else {
        frmVendorReg.controls['register.IsAgreement'].setErrors(null);
      }

      if (!this.validRecaptcha) {
        this.showRecaptchaError = true;
      } else {
        this.showRecaptchaError = false;
      }
    }
  }

  redirectTo(event) {
    this.router.navigate(['/pages/login']);
  }

  close() {
    this.showFailConfirmation = false;
    this.showSuccessConfirmation = false;
    this.validRecaptcha = false;
    this.showRecaptchaError = false;
  }

  handleCorrectCaptcha(event) {
    console.log(event);
    this.validRecaptcha = true;
    this.showRecaptchaError = false;
  }

  handleCaptchaExpired() {
    console.log('expired');
    this.validRecaptcha = false;
    this.showRecaptchaError = false;
  }

  comparePasswords(frmVendorReg: NgForm) {
    if (this.register.Password === this.register.ConfirmPassword) {
      frmVendorReg.controls['register.ConfirmPassword'].setErrors(null);
      this.isComparePasswordMatched = true;
    } else {
      frmVendorReg.controls['register.ConfirmPassword'].setErrors({'incorrect' : true});
      this.isComparePasswordMatched = false;
    }
  }

  ngOnDestroy() {
    this.alive = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/account/vendor-register/vendor-register.component.ts